import React from 'react';
import ComponentHelper from '../../supers/ComponentHelper';
import './app-composer.css';
import HeaderBreadcrumb from '../../components/header-breadcrumb/HeaderBreadcrumb';
import ComposerPanel from './concierge/ComposerPanel';

class AppComposer extends ComponentHelper {
	//TODO there will be composer panels for all the major apps and maybe a generic one in the future
	render() {
		return (
			<div className="app-composer-view animated fadeIn">
				<HeaderBreadcrumb currentPage="App Composer" />
				<ComposerPanel />
			</div>
		);
	}
}

export default AppComposer;



// WEBPACK FOOTER //
// ./src/views/app-composer/AppComposer.js